import 'fslightbox';

(() => {
  const moduleSelector = '.video-widget';

  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((module) => {
    const lightboxTrigger = module.querySelector('[data-fslightbox]');
    if (!lightboxTrigger) return;

    // Initialize fslightbox - it will automatically detect data-fslightbox attributes
    // eslint-disable-next-line no-new
    window.refreshFsLightbox();
  });
})();
